import React from "react";
import PlansSectionHeader from "./PlansSectionHeader";
import GoToContent from "./GoToContent";

const PlansSectionFreePeriod = () => {
  return (
    <>
      <PlansSectionHeader
        title="Subscribe for free"
        description=""
      />
      <hr className="w-full border-gray-500 border-b-1 my-8" />

      <div className="flex flex-col justify-center items-center px-8">
        <GoToContent />
      </div>
    </>
  );
};

export default PlansSectionFreePeriod;
